import axios from 'axios';

const state = {
  plans: [],
};

const getters = {};

const mutations = {
  setPlans(st, payload) {
    st.plans = payload;
  },
};

const actions = {
  async getPlans({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`recurly/plans`)
        .then(res => {
          commit('setPlans', res.data.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/plans.js